import { createStore } from 'vuex'
import localStorage from 'localStorage'

const authToken = localStorage.getItem('token');
const roles = localStorage.getItem('roles');

const store = createStore({
    state: {
        token: authToken !== 'null' ? authToken : null,
        roles: roles !== 'null' ? roles : null,
    },
    mutations: {
        authorize (state, token, refreshToken) {
            console.log('store authorize');
            localStorage.setItem('token', token);
            localStorage.setItem('refreshToken', refreshToken);
            state.token = token
        },
        setRoles (state, roles) {
            console.log('store setRoles', roles);
            localStorage.setItem('roles', roles);
            state.roles = roles
        },
        unauthorize (state) {
            console.log('store unauthorize');
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            state.token = null
        }
    },
    getters: {
        getToken (state) {
            return state.token;
        },
        isAuthorized (state) {
            console.log('isAuthorized', state.token, state.token !== null);
            return state.token !== null;
        },
        getRoles (state) {
            return state.roles;
        },
        isAdmin (state) {
            console.log('IS ADMIN?', typeof state.roles, state.roles);
            let adminRole = 'ADMIN';
            if (typeof state.roles == 'string') {
                let isAdmin = state.roles === adminRole;
                console.log('IS ADMIN?', isAdmin);
                return isAdmin;
            } else if (typeof state.roles == 'object' && Array.isArray(state.roles)) {
                const found = state.roles.find((element) => element === adminRole);
                return found === adminRole;
            }

            return false;
        }
    }
    /*actions: {
        authorize (context) {
            context.commit('increment')
        }
    }*/
})

/*
export const store = reactive({
    authorized: false,
})*/

export default store
